// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CJL1X","colMin":"styles_colMin__19kVk"};